import React, { createContext, Dispatch, ReactNode, SetStateAction, useMemo } from 'react';
import useWorkspaceContext from '../../hooks/context/useWorkspaceContext';
import { Dashboard, Workspace } from '../../types/files';
import storage from '../../utils/storage';

type WorkspaceContextProps = {
  workspace: Workspace | null;
  setWorkspace: Dispatch<SetStateAction<Workspace | null>>;
  workspaceDashboards: Dashboard[];
  setWorkspaceDashboards: Dispatch<SetStateAction<Dashboard[]>>;
};

export const WorkspaceContext = createContext<WorkspaceContextProps>({
  workspace: null,
  setWorkspace: () => {},
  workspaceDashboards: [],
  setWorkspaceDashboards: () => {},
});

const WorkspaceProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const {
    workspace,
    workspaceDashboards,
    setWorkspace,
    setWorkspaceDashboards,
  } = useWorkspaceContext();

  const contextValue = useMemo(() => ({
    workspace,
    setWorkspace,
    workspaceDashboards,
    setWorkspaceDashboards,
  }), [
    workspace,
    setWorkspace,
    workspaceDashboards,
    setWorkspaceDashboards,
  ]);

  if (storage.getItem('config.logger-context'))
    console.log("CTX", ["Workspace", contextValue]);

  return (
    <WorkspaceContext.Provider value={contextValue}>
      {children}
    </WorkspaceContext.Provider>
  );
};

export default WorkspaceProvider;